import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const postContributorModeratorComments = (classId, comments, isContributor) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.POST_CONTRIBUTOR_MODERATOR_COMMENTS(
      classId,
      comments,
      isContributor
    )
  );
};

export default postContributorModeratorComments;
